/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Authenticity_CertifiedInputs */

const en_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticity Certified?`)
};

const es_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Autenticidad certificada?`)
};

const fr_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticité certifiée ?`)
};

const de_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echtheit zertifiziert?`)
};

const ja_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本物鑑定済みか`)
};

const zh_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否认证正品？`)
};

const ar_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل الأصالة معتمدة؟`)
};

const id_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keaslian Tersertifikasi?`)
};

const it_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticità Certificata?`)
};

const ru_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аутентичность подтверждена?`)
};

const pt_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticidade Certificada?`)
};

const ko_field_authenticity_certified = /** @type {(inputs: Field_Authenticity_CertifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정품 인증 여부`)
};

/**
* | output |
* | --- |
* | "Authenticity Certified?" |
*
* @param {Field_Authenticity_CertifiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_authenticity_certified = /** @type {((inputs?: Field_Authenticity_CertifiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Authenticity_CertifiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_authenticity_certified(inputs)
	if (locale === "es") return es_field_authenticity_certified(inputs)
	if (locale === "fr") return fr_field_authenticity_certified(inputs)
	if (locale === "de") return de_field_authenticity_certified(inputs)
	if (locale === "ja") return ja_field_authenticity_certified(inputs)
	if (locale === "zh") return zh_field_authenticity_certified(inputs)
	if (locale === "ar") return ar_field_authenticity_certified(inputs)
	if (locale === "id") return id_field_authenticity_certified(inputs)
	if (locale === "it") return it_field_authenticity_certified(inputs)
	if (locale === "ru") return ru_field_authenticity_certified(inputs)
	if (locale === "pt") return pt_field_authenticity_certified(inputs)
	return ko_field_authenticity_certified(inputs)
});